import FaqJsonLd from './FaqJsonLd';

export default FaqJsonLd;
